import { t as uiText } from '../i18n';
/**
 * フォントスタックユーティリティ
 * 全体設定の textFontEn / textFontJp を CSS font-family に変換する
 * 適用順序: 英語（プライマリ）→ 日本語 → sans-serif
 */

const FONT_STACK_EN: Record<string, string> = {
  default: "'Inter', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
  inter: "'Inter', 'Helvetica Neue', Arial, sans-serif",
  roboto: "'Roboto', Arial, sans-serif",
  'open-sans': "'Open Sans', Arial, sans-serif",
  merriweather: "'Merriweather', Georgia, serif",
  'playfair-display': "'Playfair Display', Georgia, serif",
};

const FONT_STACK_JP: Record<string, string> = {
  default: "'Noto Sans JP', 'Hiragino Sans', 'Yu Gothic', sans-serif",
  'noto-sans-jp': "'Noto Sans JP', 'Hiragino Sans', sans-serif",
  'hiragino-sans': "'Hiragino Sans', 'Hiragino Kaku Gothic ProN', sans-serif",
  'yu-gothic': "'Yu Gothic', 'YuGothic', sans-serif",
  'noto-serif-jp': "'Noto Serif JP', 'Yu Mincho', serif",
  'yu-mincho': "'Yu Mincho', 'Yu Gothic', serif",
  'biz-udpgothic': "'BIZ UDPGothic', 'Hiragino Sans', 'Yu Gothic', sans-serif",
};

/** 英語フォントのスタックを返す（プライマリ、先に適用） */
export function getFontStackEn(value: string): string {
  return FONT_STACK_EN[value] || FONT_STACK_EN.default;
}

/** 日本語フォントのスタックを返す */
export function getFontStackJp(value: string): string {
  return FONT_STACK_JP[value] || FONT_STACK_JP.default;
}

/** 英語→日本語の順で結合した font-family を返す */
export function getCombinedFontFamily(textFontEn: string, textFontJp: string): string {
  const en = getFontStackEn(textFontEn || 'default');
  const jp = getFontStackJp(textFontJp || 'default');
  return `${en}, ${jp}`;
}

/** 英語フォント選択肢（value, label） */
export const FONT_OPTIONS_EN: { value: string; label: string }[] = [
  { value: 'default', get label() { return uiText("Default"); } },
  { value: 'inter', label: 'Inter' },
  { value: 'roboto', label: 'Roboto' },
  { value: 'open-sans', label: 'Open Sans' },
  { value: 'merriweather', label: 'Merriweather' },
  { value: 'playfair-display', label: 'Playfair Display' },
];

/** 日本語フォント選択肢（value, label） */
export const FONT_OPTIONS_JP: { value: string; label: string }[] = [
  { value: 'default', get label() { return uiText("Default"); } },
  { value: 'noto-sans-jp', label: 'Noto Sans JP' },
  { value: 'hiragino-sans', get label() { return uiText("Hiragino Kaku Gothic (Hiragino Sans)"); } },
  { value: 'yu-gothic', get label() { return uiText("Yu Gothic"); } },
  { value: 'noto-serif-jp', label: 'Noto Serif JP' },
  { value: 'yu-mincho', get label() { return uiText("Yu Mincho"); } },
  { value: 'biz-udpgothic', label: 'BIZ UDPGothic' },
];
